import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { BetaModule } from 'components/BetaModule';
import { serializeMenuItemLabel } from 'helpers/menu';

import Layout from '@eduzz/ui-layout';

import { Permission } from './Permission';
import type { Route } from './routes';
import { SubMenuRoute } from './SubMenuRoute';

const { Sidebar } = Layout;
const { Item } = Sidebar;

type MenuRouteProps = {
  route: Route;
};

const MenuRoute = React.memo(({ route }: MenuRouteProps) => {
  const isSubmenu = route.nodes?.length > 0;

  if (isSubmenu) {
    return <SubMenuRoute route={route} />;
  }

  if (route.external) {
    return (
      <Permission route={route}>
        <BetaModule module={route.betaModule}>
          <Item
            id={`menu-item-${serializeMenuItemLabel(route.label)}`}
            as={NavLink}
            to={{ pathname: route.to }}
            target='_blank'
            rel='noopener noreferrer'
            icon={route.icon || undefined}
          >
            {route.label}
          </Item>
        </BetaModule>
      </Permission>
    );
  }

  return (
    <Permission route={route}>
      <BetaModule module={route.betaModule}>
        <Item
          id={`menu-item-${serializeMenuItemLabel(route.label)}`}
          as={NavLink}
          to={route.to}
          icon={route.icon || undefined}
        >
          {route.label}
        </Item>
      </BetaModule>
    </Permission>
  );
});

export { MenuRoute };
